import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { IState, IDispatch } from './store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => IDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<IState> = useSelector;
